import { render } from "./SetupFormsTable.vue?vue&type=template&id=23130a1e&ts=true"
import script from "./SetupFormsTable.vue?vue&type=script&lang=ts"
export * from "./SetupFormsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__